module.exports = __webpack_public_path__ + "assets/be1ccf3b88ff5e61da206b8e82699ac2.mp3";